document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("ces-2026-products")) {
    class CES2026Products extends HTMLElement {
      constructor() {
        super();
        this.swiperContainer = $(this).find(".swiper-container");
        this.categories = $(this).find(".ces-2026-products-category");
        this.swiperPagination = $(this).find(".ces-2026-products-pagination");
      }

      connectedCallback() {
        this.initSwiper();
        this.initCategories();
      }

      initSwiper() {
        const self = this;
        if (this.swiperContainer.length !== 0) {
          this.swiperInstance = new Swiper(this.swiperContainer[0], {
            spaceBetween: 24,
            autoHeight: true,
            pagination: {
              el: this.swiperPagination[0],
              clickable: true,
            },
            on: {
              slideChange() {
                const category = $(self.categories[this.activeIndex]).data("category");
                self.setActiveCategory(category);
              },
            },
          });
        }
      }

      initCategories() {
        this.setActiveCategory($(this.categories[0]).data("category"));
        this.categories.each((index, el) => {
          $(el).on("click", () => {
            if (!this.swiperInstance) return;

            this.swiperInstance.slideTo(index);
          });
        });
      }

      setActiveCategory(category) {
        this.categories.each((_, el) => {
          const $el = $(el);
          if ($el.data("category") === category) {
            $el.addClass("active");

            const $container = $el.parent();
            const elLeft = el.offsetLeft;
            const elWidth = el.offsetWidth;
            const containerWidth = $container[0].clientWidth;

            const targetScrollLeft = elLeft - (containerWidth - elWidth) / 2;

            $container.stop().animate({ scrollLeft: targetScrollLeft }, 300);
          } else {
            $el.removeClass("active");
          }
        });
      }
    }
    customElements.define("ces-2026-products", CES2026Products);
  }

  window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.type == "submit") {
      const $buttons = $(".ces-2026-products .ces-2026-product-subscribe-button");

      $buttons.text("Coming Soon").addClass("button-disabled");
    }
  });

  window.addEventListener("full-screen-modal-open", function (e) {
    $(e.detail?.contentEl).find("input").focus();
  });

  $(".ces-2026-product-image, .ces-2026-product-name").click(function () {
    $(this).closest(".ces-2026-product").find(".ces-2026-product-button")[0]?.click();
  });
});
